import ChallengeView from '@/views/challenges/Challenge';
import ChallengePartnerView from '@/views/challenges/ChallengePartner';
import AddChallengePartnerView from '@/views/challenges/AddChallengePartner';

export default ([
  {
    path: '/challenges/:challengeSlug',
    component: ChallengeView,
    name: 'Challenge',
    meta: { requiresAuth: true, authorize: ['reports'] },
  },
  {
    path: '/challenges/:challengeSlug/partners/new',
    component: AddChallengePartnerView,
    name: 'Add Challenge Partner',
    meta: { requiresAuth: true, authorize: ['reports'] },
  },
  {
    path: '/challenges/:challengeSlug/partners/:partnerSlug',
    component: ChallengePartnerView,
    name: 'Challenge Partner',
    meta: { requiresAuth: true, authorize: ['reports'] },
  },
]);
